import React from 'react';
import type { FlexProps } from '@chakra-ui/react';
import VerticalProductCardSkeleton from './VerticalProductCard.Skeleton';
import HorizontalProductCardSkeleton from './HorizontalProductCard.Skeleton';

type ProductCardSkeletonProps = {
  orientation: 'vertical' | 'horizontal';
} & FlexProps;

const ProductCardSkeleton = ({ orientation, ...props }: ProductCardSkeletonProps) => {
  if (orientation === 'horizontal') {
    return <HorizontalProductCardSkeleton {...props} />;
  }

  return <VerticalProductCardSkeleton {...props} />;
};

export default ProductCardSkeleton;
